import {
  getBillCycle,
  getNoOfBillProfiles,
  getBillHistory,
  createBillCycle,
  getBillHistoryById,
  updateBillHistoryById,
  createBillHistory
} from "@/http/billManagement";

export default {
  namespaced: true,
  state: {
    billCycleList: null,
    noOfBillProfiles: null,
    billHistoryList: null,
    billHistoryByIdList: null,
  },
  actions: {
    async getBillHistoryActionById({ commit }, id) {
      const resp = await getBillHistoryById(id);
      commit("GET_BILL_HISTORY_By_Id", resp.data);
      return resp;
    },
    async getBillCycleAction({ commit }) {
      const resp = await getBillCycle();
      commit("GET_BILL_CYCLE", resp.data.pageItems);
      return resp;
    },
    async getNoOfBillProfilesAction({ commit }) {
      const resp = await getNoOfBillProfiles();
      commit("GET_NO_OF_BILL_PROFILES", resp.data.pageItems);
      return resp;
    },
    async getBillHistoryAction({ commit }) {
      const resp = await getBillHistory();
      const seen = new Set();
      let arr = resp.data.pageItems;
      arr = arr.filter(item => {
        if (seen.has(item.billCycleName)) {
          return false;
        }
        seen.add(item.billCycleName);
        return true;
      });
      commit("GET_BILL_HISTORY", arr);
      return resp;
    },
    async createBillCycleAction(_, data) {
      const resp = await createBillCycle(data);
      return resp;
    },
    async createBillHistoryAction(_, data) {
      const resp = await createBillHistory(data);
      return resp;
    },
    async updateBillHistoryByIdAction(_, data) {
      const resp = await updateBillHistoryById(data);
      return resp;
    },
  },
  mutations: {
    GET_BILL_CYCLE(state, payload) {
      state.billCycleList = payload;
    },
    GET_NO_OF_BILL_PROFILES(state, payload) {
      state.noOfBillProfiles = payload;
    },
    GET_BILL_HISTORY(state, payload) {
      state.billHistoryList = payload;
    },
    GET_BILL_HISTORY_By_Id(state, payload) {
      state.billHistoryByIdList = payload;
    }
  },
};
